import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

function OptimizeModal({
  modalBody, modalFooter, show, onClose, ...props
}) {
  const modalRef = useRef();
  const [modalInstance, setModalInstance] = useState();

  useEffect(() => {
    const modalElement = modalRef.current;
    if (!modalElement) return;
    setModalInstance(new window.bootstrap.Modal(modalElement));
    modalElement.addEventListener('hidden.bs.modal', onClose);
  }, []);

  useEffect(() => {
    if (!modalInstance) return;
    if (show) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
  }, [show, modalInstance]);

  return (
    <div
      className="modal fade theme-modal qty-modal"
      tabIndex="-1"
      aria-hidden="true"
      ref={modalRef}
      {...props}
    >
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content">
          <div className="modal-body">
            {modalBody}
          </div>
          <div className="modal-footer">
            {modalFooter}
          </div>
        </div>
      </div>
    </div>
  );
}

OptimizeModal.defaultProps = {
  modalFooter: null,
  modalBody: null,
  onClose: () => {},
};

OptimizeModal.propTypes = {
  modalBody: PropTypes.node,
  modalFooter: PropTypes.node,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

export default OptimizeModal;
